import React from "react";

import { Box } from "@mui/material";

import Images from "./ProductBuilderImage.utils";

type Props = {
    qcomHwChecked: boolean;
    nxpHwChecked: boolean;
    customHwChecked: boolean;
    headlessChecked: boolean;
    kioskChecked: boolean;
    customUiChecked: boolean;
    cloudChecked: boolean;
    fleetChecked: boolean;
    fleetAnalyticsChecked: boolean;
};

export const ProductBuilderImage = (props: Props) => {
    const [hardwareImage, setHardwareImage] = React.useState("");
    const [serviceImage, setServiceImage] = React.useState("");

    React.useEffect(() => {
        setHardwareImage("");
        setServiceImage("");

        if (props.nxpHwChecked) {
            setHardwareImage(Images.hardware.nxp);
            if (props.headlessChecked) {
                setHardwareImage(Images.hardware.nxpScreenOffKioskOff);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.nxpScreenOffKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.nxpScreenOffCustomizeOn);
                }
            } else {
                setHardwareImage(Images.hardware.nxpScreenOn);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.nxpKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.nxpScreenOnCustomizeOn);
                }
            }
        }

        if (props.qcomHwChecked) {
            setHardwareImage(Images.hardware.qualcomm);
            if (props.headlessChecked) {
                setHardwareImage(Images.hardware.qualcommScreenOffKioskOff);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.qualcommScreenOffKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.qualcommScreenOffCustomizeOn);
                }
            } else {
                setHardwareImage(Images.hardware.qualcommScreenOn);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.qualcommKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.qualcommScreenOnCustomizeOn);
                }
            }
        }

        if (props.customHwChecked) {
            setHardwareImage(Images.hardware.customhw);
            if (props.headlessChecked) {
                setHardwareImage(Images.hardware.customhwScreenOffKioskOff);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.customhwScreenOffKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.customhwScreenOffCustomizeOn);
                }
            } else {
                setHardwareImage(Images.hardware.customhwScreenOn);
                if (props.kioskChecked) {
                    setHardwareImage(Images.hardware.customhwKioskOn);
                } else if (props.customUiChecked) {
                    setHardwareImage(Images.hardware.customhwScreenOnCustomizeOn);
                }
            }
        }

        if (props.cloudChecked) {
            setServiceImage(Images.services.dataManagement);
        }

        if (props.fleetChecked) {
            setServiceImage(Images.services.fleetManagement);
        }

        if (props.fleetAnalyticsChecked) {
            setServiceImage(Images.services.fleetAnalytics);
        }

        if (props.cloudChecked && props.fleetChecked) {
            setServiceImage(Images.services.dataAndFleetManagement);
        }

        if (props.cloudChecked && props.fleetAnalyticsChecked) {
            setServiceImage(Images.services.dataAndFleetAnalytics);
        }

        if (props.fleetChecked && props.fleetAnalyticsChecked) {
            setServiceImage(Images.services.fleetAndFleetAnalytics);
        }

        if (props.cloudChecked && props.fleetChecked && props.fleetAnalyticsChecked) {
            setServiceImage(Images.services.allServices);
        }
    }, [
        props.qcomHwChecked,
        props.nxpHwChecked,
        props.customHwChecked,
        props.headlessChecked,
        props.kioskChecked,
        props.customUiChecked,
        props.cloudChecked,
        props.fleetChecked,
        props.fleetAnalyticsChecked,
        hardwareImage,
        serviceImage,
    ]);

    return (
        <Box
            sx={{
                height: "120%",
                width: "120%",
                backgroundImage: `url(${hardwareImage}), url(${serviceImage})`,
                backgroundSize: "contain, contain",
                backgroundPosition: "center, center",
                backgroundRepeat: "no-repeat, no-repeat",
            }}
        />
    );
};
